import React from "react";
import { useState } from "react";
import {
  AnimatePresence,
  motion,
} from "framer-motion/dist/framer-motion";
import "./styles.css";

export function Box() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <motion.div
      layout
      data-isOpen={isOpen}
      initial={{ borderRadius: 50 }}
      className="parent"
      onClick={() => setIsOpen(!isOpen)}
    >
      <motion.div layout className="child" />
    </motion.div>
  );
}
